import React from 'react';
import home from '../img/home.png';
import group from '../img/group.webp';
import book from '../img/book.webp';
import manual from '../img/manual.png';
import lamp from '../img/lamp.png';
import { Link } from 'react-router-dom';
const Home = () => {
    return (
        <>

        {/* HOME SECTION  */}
        <div className='home'>
            <div className='glass_box'>
            </div>
            <section className='home_section blur'>
                <div className='container home_container'>
                    <div className='home_item home_item-1 flex center'>
                        <img src={home} />
                    </div>
                    <div className='home_item home_item-2'>
                        <div className='home_item-content flex center'>
                            <h2>
                                Samarqand Davlat universiteti
                                o'qituvchilarni baholash tizimi
                            </h2>
                        </div>
                        <div className='home_item-button flex center'>
                            <Link to="/information">
                                <button className='btn btn-succses'>Ishtirok etish</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        {/* PURPOSE SECTION  */}
        <div className='purpose'>
            <div className='glass_box purpose-glas'>
            </div>
            <section className='purpose_section blur'>
                <div className='container purpose_container'>
                    <div className='purpose_item-content'>
                        <h2>
                            Maqsad nima?
                        </h2>
                        <p>
                            O'qituvchilarni baholash orqali quyidagi natijalarga erishamiz
                        </p>
                    </div>
                    <div className='purpose_item-box grid'>
                        <div className='purpose_box flex center'>
                            <img src={group} /> 
                            <p>Darslarga munosib o'qituvchilarni tayinlash</p>
                        </div>
                        <div className='purpose_box flex center'>
                            <img src={book} />
                            <p>Ta'lim sifatini oshirish</p> 
                        </div>
                    </div>
                </div>
                
            </section>
        </div>

        {/* MANUAL SECTION  */}

        <div className='manual'>
            <div className='glass_box manual-glas'>
            </div>
            <section className='manual_section blur'>
                <div className='container'>
                    <div className='manual_item-content'>
                        <h2>
                            Yo'riqnoma
                        </h2>
                        <p>
                            Tizimdan foydalanish qo'lanmasi
                        </p>
                    </div>
                    <div className='manual_container'>
                        <div className='manual_item-img flex center'>
                            <img src={manual} />
                        </div>
                        <div className='manual_item-box grid'>
                        <div className='manual_box flex'>
                            <div className='manual_box-img flex center'>
                                <img src={lamp} />
                            </div>
                            <div className='manual_box-description'>
                                <p>Dastlab bosh sahifadagi ishtirok etish tugmasi bosiladi</p>
                            </div>
                        </div>
                        <div className='manual_box  flex'>
                            <div className='manual_box-img flex center'>
                                <img src={lamp} />
                            </div>
                            <div className='manual_box-description'>
                                <p>Yunalish, fakultet, kursingiz va guruhingizni tanlang</p>
                            </div>
                        </div>
                        <div className='manual_box flex'>
                            <div className='manual_box-img flex center'>
                                <img src={lamp} />
                            </div>
                            <div className='manual_box-description'>
                                <p>Agar sizning guruhingizga ovoz berishga ruhsat berilgan bo'lsa surovnomada ishtirok eta olasiz</p>
                            </div>
                        </div>
                        <div className='manual_box flex'>
                            <div className='manual_box-img flex center'>
                                <img src={lamp} />
                            </div>
                            <div className='manual_box-description'>
                                <p>Unutmang! har bir talaba faqat o'zi uchun ishtirok eta oladi</p>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        </div>
        <footer>
            <div className='container'>
                <h2>
                    Samarqand Davlat universiteti
                    o'qituvchilarni baholash tizimi
                </h2>
                <div className='footer-container'>
                    <div className='footer_item'>
                        <h4>Bo'limlar</h4>
                        <ul className='footer_list'>
                            <li>Maqsad</li>
                            <li>Qo'lanma</li>
                        </ul>
                    </div>
                    <div className='footer_item'>
                        <h4>Saytlar</h4>
                        <ul className='footer_list'>
                            <li><a href='https://www.samdu.uz/uz'>Samarqand Davlat Universiteti</a></li>
                            <li><a href='https://my.samdu.uz'>Samarqand Davlat universiteti xizmatlar portali</a></li>
                        </ul>
                    </div>
                    
                </div>
                <p className='site_about'>
                    <a href='http://surovnoma.samdu.uz'>surovnoma.samdu.uz </a> © 2022. Barcha huquqlar himoyalangan.
                </p>
            </div>
        </footer>
        </>

    );
};


export default Home;